//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { map } from '@/assets/js/map';
import {
  getMajor,
  getCredit, getCreditIndustrys, getJobTitle, getEducation, getIndustry,
  getServiceContents, getServiceTypez, getBusinessType
} from '@/assets/js/dict';
export default {
  created() {
    getMajor().then(res => {
      this.majors = res;
    })
    getCredit().then(res => {
      this.credits = res;
    })
    getCreditIndustrys().then(res => {
      this.creditIndustrys = res;
    })
    getJobTitle().then(res => {
      this.jobTitles = res;
    })
    getEducation().then(res => {
      this.educations = res;
    })
    getServiceContents().then(res => {
      this.serviceList = res;
    })
    getIndustry().then(res => {
      this.industrys = res
    })
    getServiceTypez().then(res => {
      this.serviceTypeList = res
    })
    getBusinessType().then(res => {
      this.businessList = res
    })
  },
  data: () => ({
    info: '',
    userPersonalExpertParam: '', //个人信息
    userEnterprise: '', //企业信息
    userStudio: '', //工作室信息
    majors: [],
    industrys: [],
    credits: [],
    creditIndustrys: [],
    jobTitles: [],
    educations: [],
    serviceList: [],
    serviceTypeList: [],
    businessList: [],
    provideName: '',
    cityName: '',
    countryName: '',
    activeName: 'first',
    activeNames: 'first',
    userBusinessParamListP: [],
    userBusinessParamListW: [],
    userBusinessParamListF: []
  }),
  methods: {
    //获取个人信息
    getInfo() {
      this.$get('/sys/user/info', '', function (res) {
        this.info = res.data;
        this.userBusinessParamListP = []
        this.userBusinessParamListW = []
        this.userBusinessParamListF = []
        var userBusinessParamList = res.data.userBusinessParamList
        for (var i = 0; i < userBusinessParamList.length; i++) {
          if (userBusinessParamList[i].settledType == 1) {
            this.userBusinessParamListP.push(userBusinessParamList[i])
          }
          if (userBusinessParamList[i].settledType == 2) {
            this.userBusinessParamListW.push(userBusinessParamList[i])
          }
          if (userBusinessParamList[i].settledType == 3) {
            this.userBusinessParamListF.push(userBusinessParamList[i])
          }
        }
        this.userPersonalExpertParam = res.data.userPersonalExpertParam; //个人信息
        var year = new Date(res.data.userPersonalExpertParam.workYears).getFullYear();
        var newdate = new Date();
        var nowyear = newdate.getFullYear();
        var yearc = nowyear - year;
        if (yearc < 3) {
          this.userPersonalExpertParam.workYears = '3年以下'
        } else if (yearc > 10) {
          this.userPersonalExpertParam.workYears = '10年以上'
        } else {
          this.userPersonalExpertParam.workYears = '3-10年'
        }
        if (!res.data.consumerType) {
          res.data.consumerType = 1;
        }
        if (!res.data.providerType) {
          res.data.providerType = 1;
        }
        if (res.data.consumerType == 1 || res.data.providerType == 1) {
          var codes = '';
          if (res.data.userPersonalExpertParam.contactAddressCode) {
            codes = res.data.userPersonalExpertParam.contactAddressCode.split(',');
          }
          for (let item in map) {
            if (item == codes[0]) {
              this.userPersonalExpertParam.provideName = map[item];
            }
            if (item == codes[1]) {
              this.userPersonalExpertParam.cityName = map[item];
            }
            if (item == codes[2]) {
              this.userPersonalExpertParam.countryName = map[item];
            }
          }
        }
        this.userEnterprise = res.data.userEnterprise; //企业信息
        if (res.data.consumerType == 3 || res.data.providerType == 3) {
          var codesd = '';
          if (res.data.userEnterprise.contactAddressCode) {
            codesd = res.data.userEnterprise.contactAddressCode.split(',');
          }
          for (let item in map) {
            if (item == codesd[0]) {
              this.userEnterprise.provideName = map[item];
            }
            if (item == codesd[1]) {
              this.userEnterprise.cityName = map[item];
            }
            if (item == codesd[2]) {
              this.userEnterprise.countryName = map[item];
            }
          }
        }
        this.userStudio = res.data.userStudio; //工作室信息
        if (res.data.providerType == 2) {
          var codess = '';
          if (res.data.userStudio.contactAddressCode) {
            codess = res.data.userStudio.contactAddressCode.split(',');
          }
          for (let item in map) {
            if (item == codess[0]) {
              this.userStudio.provideName = map[item];
            }
            if (item == codess[1]) {
              this.userStudio.cityName = map[item];
            }
            if (item == codess[2]) {
              this.userStudio.countryName = map[item];
            }
          }
        }
      })
    },

    // 去认证
    authentication() {
      this.$router.push({
        path: '/person/authenticChoose?type=' + this.info.currentUserType
      })
    },

    // 撤销认证
    exitAuthentic() {
      this.$confirm('确定要撤销认证吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var form = {
          currentUserType: this.info.currentUserType
        }
        this.$put('/sys/user/cancel/auth', form, function (res) {
          if (res.code == 200) {
            this.$message.success('已撤销认证!');
            this.getInfo()
          } else {
            this.$message.error(res.msg);
          }
        }, true)
      })
    }


  },
  mounted() {
    this.getInfo();
  }
}
